const io = require('socket.io-client');
const feathers = require('@feathersjs/feathers');
const socketio = require('@feathersjs/socketio-client');
const auth = require('@feathersjs/authentication-client');

export const API_URL = process.env.REACT_APP_TICKER_API;
export const STORAGE_URL = process.env.REACT_APP_STORAGE_API;
export const AVATAR_URL = process.env.REACT_APP_AVATARURL;
export const IMAGE_URL = process.env.REACT_APP_IMAGEURL;
export const TRADINGBRIDGE = process.env.REACT_APP_TRADING_API;
export const BROKERID = process.env.REACT_APP_BROKER_ID;

export const EMAIL_METHOD = process.env.REACT_APP_EMAIL_METHOD;
export const EMAIL_API = process.env.REACT_APP_EMAIL_API;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const INVESTOR_API_URL = process.env.REACT_APP_INVESTOR_API;

export const BROKER_LOGO = process.env.REACT_APP_LOGO;
export const BROKER_LOGO_WIDTH = process.env.REACT_APP_LOGO_WIDTH;
export const BROKER_LOGO_SYMBOL = process.env.REACT_APP_LOGO_SYMBOL;
export const BROKER_BG = process.env.REACT_APP_BG;
export const BROKER_NAME = process.env.REACT_APP_BROKERNAME;
export const BROKER_SHORT = process.env.REACT_APP_BROKERSHORT;
export const BROKER_POSITION = process.env.REACT_APP_BROKERPOSITION;
export const BROKER_EMAIL = process.env.REACT_APP_BROKER_EMAIL;
export const BROKER_EMAIL_LOGO = process.env.REACT_APP_EMAIL_LOGO;
export const BROKER_EMAIL_MASTHEAD = process.env.REACT_APP_EMAIL_MASTHEAD;

export const COLOR_SCHEME = process.env.REACT_APP_COLOR_MODE;

export const ENABLED_CURRENCIES = JSON.parse(process.env.REACT_APP_CURRENCIES);
export const CREDIT_CARD_DEPOSIT = process.env.REACT_APP_CCPROVIDER;
export const CXPAY_URL = 'https://de.earlybirdfunding.com/CXAPM.php';

export const ENABLED_LANGUAGES = JSON.parse(process.env.REACT_APP_LANGUAGES);
export const SMS_VERIFICATION = (process.env.REACT_APP_ENABLE_SMS_VERIFICATION === 'true');
export const IN_APP_TOS = (process.env.REACT_APP_ENABLE_IN_APP_TOS === 'true');
export const DCSX_BASE_URL = process.env.REACT_APP_DCSX_BASE_URL || '';

export const DISABLE_REGISTRATION = (process.env.REACT_APP_DISABLE_REGISTRATION === 'true');
export const DISABLE_LOGIN = (process.env.REACT_APP_DISABLE_LOGIN === 'true');

export const DISABLE_UPLOAD_POI = (process.env.REACT_APP_DISABLE_UPLOAD_POI === 'true');
export const DISABLE_UPLOAD_POA = (process.env.REACT_APP_DISABLE_UPLOAD_POA === 'true');
export const DISABLE_UPLOAD_SPD = (process.env.REACT_APP_DISABLE_UPLOAD_SPD === 'true');
export const DISABLE_UPLOAD_POD = (process.env.REACT_APP_DISABLE_UPLOAD_POD === 'true');
export const READONLY_IDENT = (process.env.REACT_APP_READONLY_IDENT === 'true');
export const READONLY_ADDRESS = (process.env.REACT_APP_READONLY_ADDRESS === 'true');

export const HIDE_BROKERNAME_ON_LOGIN = (process.env.REACT_APP_HIDE_BROKER_ON_LOGIN === 'true');

export const DISABLE_DEPOSIT = (process.env.REACT_APP_DISABLE_DEPOSIT === 'true');
export const DISABLE_WITHDRAWAL = (process.env.REACT_APP_DISABLE_WITHDRAWAL === 'true');

export const DISABLED_PRIMARY_NAVIGATION = (process.env.REACT_APP_DISABLED_PRIMARY_NAVIGATION) ? JSON.parse(process.env.REACT_APP_DISABLED_PRIMARY_NAVIGATION) : [];
export const DISABLED_SECONDARY_NAVIGATION = (process.env.REACT_APP_DISABLED_SECONDARY_NAVIGATION) ? JSON.parse(process.env.REACT_APP_DISABLED_SECONDARY_NAVIGATION) : [];

export const USERNAME_FIELD = (process.env.REACT_APP_USERNAME_FIELD) ? process.env.REACT_APP_USERNAME_FIELD : null;

//TODO: Also in i18n due to race condition
export const ADDITIONAL_LANGUAGE_FILE = (process.env.REACT_APP_ADDITIONAL_LANGUAGE_FILE) ? process.env.REACT_APP_ADDITIONAL_LANGUAGE_FILE : null;

export const HOME_PAGE_TEXT_ALIGNMENT = (process.env.REACT_APP_HOME_TEXT_ALIGN) ? process.env.REACT_APP_HOME_TEXT_ALIGN : 'left';
export const HOME_PAGE_TEXT_COLOR = (process.env.REACT_APP_HOME_TEXT_COLOR) ? process.env.REACT_APP_HOME_TEXT_COLOR : 'inherit';

let agents = false;

try {
  agents = JSON.parse(process.env.REACT_APP_AGENTS);
} catch (e){
  agents = false;
}

export const AGENTS = agents;

const socket = io(process.env.REACT_APP_INVESTOR_API,{
  //transports: ['websocket'],
  forceNew: true
});

const client = feathers();
client.configure(auth({
  strategy: 'local',
  storage: window.localStorage
}));
client.configure(socketio(socket, {timeout:40000}));

export const API = client;


export function CONSOLE(output){
  if(process.env.NODE_ENV !== 'production'){
    console.log(output)
  }
}
